import type { OnboardingDetails, OnboardingValidationIssue } from "./onboarding-api.types"

/**
 * Mirrors the first entry in the component mock-data (Aisha Khan / Northwind Retail).
 * decisions is null so the form populates from the Layer 1 snapshot — avoids needing
 * real numeric IDs for LOB / internal company in mock mode.
 */
export const mockOnboardingDetails: OnboardingDetails = {
  id: "00000000-0000-0000-0000-000000000001",
  status: "PendingReview",
  sourceType: "ATS",
  sourceId: "10001",
  placement: {
    workerProfileTypeCode: "WorkerTemp",
    clientDisplayName: "Northwind Retail",
    startDate: "2026-03-01",
    endDate: "2026-08-31",
    primaryBillingRate: 95,
    primaryPaymentRate: 62,
    billingCurrency: "CAD",
    paymentCurrency: "CAD",
    supplier: null,
  },
  worker: {
    firstName: "Aisha",
    lastName: "Khan",
    fullName: "Aisha Khan",
    primaryEmail: "aisha.khan@example.com",
  },
  decisions: null,
  outcome: null,
  createdAt: "2026-01-10T00:00:00Z",
}

/** What the preflight says about the mock placement when a new organization is created. */
export const mockPreflightIssues: OnboardingValidationIssue[] = [
  {
    field: "worker.mobilePhone",
    destination: "UserProfilePhone.Phone",
    incomingValue: "+34 656210711719244",
    resultingValue: null,
    rule: "maximum 15 digits; this is 17",
    consequence: "ValueNotStored",
    blocking: false,
    fixLocation: "Ats",
    fixRecord: "worker 3746569 — Anil Pochampally",
  },
  {
    field: "workerOrganization.type",
    destination: "Organization.OrganizationTypeCode",
    incomingValue: "Vendor",
    resultingValue: null,
    rule: "required, and the value the ATS sent could not be used",
    consequence: "RecordIncomplete",
    blocking: false,
    fixLocation: "AtsFieldMapping",
    fixRecord: "supplier 12049 — System Soft Technologies LLC",
  },
  {
    field: "workerOrganization.address.addressLine1",
    destination: "OrganizationAddress.AddressLine1",
    incomingValue: "Suite 1200, 1234 Some Very Long Street Name That Goes On And On, Business Park, Tower Two, Floor Twelve, Reception Desk B, Attention Accounts",
    resultingValue: null,
    rule: "maximum 130 characters; this is 142",
    consequence: "RecordIncomplete",
    blocking: false,
    fixLocation: "Ats",
    fixRecord: "supplier 12049 — System Soft Technologies LLC",
  },
  {
    field: "workerOrganization.countryOfRegistration",
    destination: "Organization.CountryCode",
    incomingValue: "USA",
    resultingValue: "US",
    rule: "the value the ATS sent could not be used; the address country was used instead, and it also selects which tax identifier the role receives",
    consequence: "ValueReplaced",
    blocking: false,
    fixLocation: "AtsFieldMapping",
    fixRecord: "supplier 12049 — System Soft Technologies LLC",
  },
  {
    field: "workerOrganization.paymentNotificationEmail",
    destination: "OrganizationRole.NotificationEmail",
    incomingValue: null,
    resultingValue: null,
    rule: "required; no address is mapped for this organization in the ATS Hub, so it has to be completed in FBO",
    consequence: "RecordIncomplete",
    blocking: false,
    fixLocation: "Fbo",
    fixRecord: "supplier 12049 — System Soft Technologies LLC",
  },
]

export const mockBlockingPreflightIssue: OnboardingValidationIssue = {
  field: "workerOrganization.legalName",
  destination: "Organization.LegalName",
  incomingValue: null,
  resultingValue: "System Soft Technologies LLC Incorporated Holdings Of North America And Affiliated Entities Group Limited Partnership Trust Co",
  rule: "maximum 128 characters; this is 129",
  consequence: "RecordNotCreated",
  blocking: true,
  fixLocation: "Fbo",
  fixRecord: null,
}
